// Global packages and components
import { useEffect, useState } from 'react'
import { motion } from 'framer-motion'
import { ContentEditor } from '~/components'
import { useWindowDimensions } from '~/hooks'

// Types
import type { SanityCustomImage } from '~/types'

type GridProps = {
  content: any
  items?: Array<{ logo: SanityCustomImage }>
}

// Main component
export default function LogoGrid({ content, items }: GridProps) {
  const [transitionTime, setTransitionTime] = useState(25)
  const { width } = useWindowDimensions()

  // Update transition time when width changes
  useEffect(() => {
    if (width && width <= 500) {
      setTransitionTime(5)
    } else if (width && width <= 768) {
      setTransitionTime(10)
    } else {
      setTransitionTime(20)
    }
  }, [width])

  if (!items) return null

  const duplicatedItems = [...items, ...items, ...items, ...items, ...items]

  return (
    <>
      {content && (
        <div className="animate-in slide-from-bottom container mb-16 px-16 text-center">
          <ContentEditor content={content} />
        </div>
      )}
      <div className="">
        <div className="relative block w-full overflow-hidden">
          {/* Wrapping div for seamless looping */}
          <motion.div
            className="flex items-center justify-center"
            animate={{
              x: ['0%', '-100%'],
              transition: {
                ease: 'linear',
                duration: transitionTime,
                repeat: Infinity,
              },
            }}
          >
            {/* Render duplicated slides */}
            {duplicatedItems.map((item, i) => (
              <div
                key={i}
                className="flex h-20 w-52 flex-shrink-0 items-center justify-center px-6"
              >
                {item.logo && (
                  <img
                    src={item.logo.asset.url}
                    alt={item.logo.alt}
                    className="max-h-full max-w-full object-contain"
                  />
                )}
              </div>
            ))}
          </motion.div>
        </div>
      </div>
    </>
  )
}
